import { SolidExclamationCircleIcon } from '@tempmee/react-icons';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Row } from '~/commonComponents';
import { EnforcePostAJobFunnelImprovements } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

export const GeneralErrorMessage = () => {
  const isEnforcePostAJobFunnelImprovement = useFeatureFlag(EnforcePostAJobFunnelImprovements);

  return (
    <Row
      gap={6}
      alignItems="center"
      {...(isEnforcePostAJobFunnelImprovement ? { width: 800 } : { marginBottom: 16 })}
    >
      <SolidExclamationCircleIcon color={colors.error[500]} />
      <Typography as="span" color={colors.error[500]}>
        Oops! It looks like a few required fields were left empty.
      </Typography>
    </Row>
  );
};
